import { serialize as domFormSerializer } from "dom-form-serializer";

export const leadFormVueConfig = {
    el: "#lead-form-app",
    data() {
        return {
            currentButtonLabel: "",
            currentStep: 1,
            errors: [],
            completed: false,
            steps: [],
            subcategoryId: null,
            loading: false,
            region: {
                prefilled: false,
                zipcode_checker_done: false,
                city: null,
                postalCode: null,
                street: null,
                streetNumber: null,
                country: document.querySelector("input[name=website_country]")
                    .value,
            },
        };
    },
    methods: {
        initSteps() {
            let stepData = document.querySelectorAll("form .form-step");
            stepData.forEach((elem) => {
                this.steps.push({
                    step: Number(elem.dataset.step),
                    buttonLabel: elem.dataset.buttonLabel,
                });
            });
        },
        initSubcategory() {
            this.subcategoryId =
                document.getElementById("subcategory_id").options[0].value;
        },
        updateForm() {
            let stepData = this.steps.find((x) => x.step === this.currentStep);
            this.currentButtonLabel = stepData.buttonLabel;
            this.clearErrors();
        },
        clearErrors() {
            if (this.errors.length === 0) {
                return;
            }

            this.errors = [];
            document.querySelectorAll(".is-invalid").forEach((elem) => {
                elem.classList.remove("is-invalid");
            });
            document.querySelectorAll(".invalid-feedback").forEach((elem) => {
                elem.classList.remove("d-block");
            });
        },
        showErrors() {
            Object.entries(this.errors).forEach((error) => {
                let fieldName = error[0];
                let message = error[1];
                document
                    .querySelectorAll(`[name="${fieldName}"]`)
                    .forEach((elem) => {
                        if (elem.classList.contains("form-control")) {
                            elem.classList.add("is-invalid");
                        }

                        let feedbackElement = elem
                            .closest(".form-group")
                            .querySelector(".invalid-feedback");
                        feedbackElement.innerText = message;
                        feedbackElement.classList.add("d-block");
                    });
            });
        },
        submitForm() {
            this.clearErrors();
            this.loading = true;
            axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content");

            axios
                .post(
                    document.querySelector("form").action,
                    domFormSerializer(document.querySelector("form"))
                )
                .then((response) => {
                    if (false === response.data.completed) {
                        ++this.currentStep;
                        this.updateForm();
                    } else {
                        this.completed = true;
                        if (document.getElementById("redirectUrl").value) {
                            window.top.location.href =
                                document.getElementById("redirectUrl").value;
                        }
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        let errorResponseData = error.response.data;

                        if (errorResponseData.globalError === true) {
                            alert(errorResponseData.message);
                        } else {
                            this.errors = errorResponseData.errors;
                        }
                    } else {
                        alert(
                            "Sorry, er is iets misgegaan. Ga naar www.offerteadviseur.nl om uw offerteaanvraag te voltooien."
                        );
                    }
                    this.loading = false;
                });
        },
        getSubcategoryFormFields() {
            let formFieldsContainer = document.getElementById(
                "subcategory-form-fields"
            );
            this.clearCurrentSubcategoryFormFields(formFieldsContainer);

            axios
                .post(formFieldsContainer.dataset.endpointUrl, {
                    subcategory_id: this.subcategoryId,
                })
                .then((response) => {
                    let formFields = document
                        .createRange()
                        .createContextualFragment(response.data);
                    formFieldsContainer.appendChild(formFields);
                })
                .catch((error) => {
                    alert(
                        "Sorry, er is iets misgegaan. Ga naar www.offerteadviseur.nl om uw offerteaanvraag te voltooien."
                    );
                    throw error;
                });
        },
        clearCurrentSubcategoryFormFields(formFieldsContainer) {
            while (formFieldsContainer.hasChildNodes()) {
                formFieldsContainer.removeChild(formFieldsContainer.firstChild);
            }
        },
        checkPostalCode() {
            const dutchPostalcodeRegex =
                /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
            const belgiumPostalcodeRegex = /^[1-9]{1}[0-9]{3}$/;
            switch (this.region.country) {
                case "Nederland":
                    return dutchPostalcodeRegex.test(this.region.postalCode)
                        ? ["visible"]
                        : ["invisible"];

                case "België":
                    return belgiumPostalcodeRegex.test(this.region.postalCode)
                        ? ["visible"]
                        : ["invisible"];
            }
        },
        fetchPostalData() {
            if (this.region.postalCode && !this.region.streetNumber) {
                this.prefillStreetAndCity(this.region.postalCode);
                return;
            }
            if (
                this.region.postalCode == null ||
                this.region.streetNumber == null
            ) {
                return;
            }

            if (this.region.country !== "Nederland") {
                return;
            }

            if (this.region.city && this.region.street) {
                return;
            }

            axios
                .post("/api/postcode", {
                    postalCode: this.region.postalCode,
                    streetNumber: this.region.streetNumber,
                })
                .then((response) => {
                    let data = response.data.data;
                    let status = response.data.status;

                    if (status === 200) {
                        this.region.city = data.city;
                        this.region.postalCode = data.postcode;
                        this.region.street = data.street;
                        this.region.streetNumber = data.number;
                    }
                })
                .catch(function (error) {
                    console.error(error);
                });
        },
        prefillStreetAndCity(postalCode) {
            axios
                .post("/api/postcode", {
                    postalCode: postalCode,
                })
                .then((response) => {
                    let data = response.data.data;
                    let status = response.data.status;
                    this.region.zipcode_checker_done = true;
                    if (status === 200) {
                        this.region.city = data.city;
                        this.region.street = data.street;

                        if (this.region.city && this.region.street) {
                            this.region.prefilled = true;
                        } else {
                            this.region.prefilled = false;
                        }
                    }
                })
                .catch(function (error) {
                    this.region.zipcode_checker_done = true;
                    console.error(error);
                });
        },
        getPostalCode() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.get("postal_code")) {
                this.region.postalCode = urlParams
                    .get("postal_code")
                    ?.toUpperCase();
            } else {
                this.region.postalCode = urlParams
                    .get("postcode")
                    ?.toUpperCase();
            }

            if (this.region.postalCode) {
                this.prefillStreetAndCity(this.region.postalCode);
            }
        },
    },
    mounted() {
        this.initSteps();
        this.updateForm();
        this.initSubcategory();
        this.getPostalCode();
    },
    watch: {
        errors: function () {
            this.showErrors();
        },
        subcategoryId: function () {
            this.getSubcategoryFormFields();
        },
    },
};
